import { useAtomValue } from "jotai";
import { DebugType } from "./DebugType";
import { debugSettingSelector } from "./debugSettingState";
export function useDebugOptions() {
    return {
        [DebugType.Configuration]: useAtomValue(debugSettingSelector(DebugType.Configuration)),
        [DebugType.Attributes]: useAtomValue(debugSettingSelector(DebugType.Attributes)),
        [DebugType.Values]: useAtomValue(debugSettingSelector(DebugType.Values)),
        [DebugType.Groups]: useAtomValue(debugSettingSelector(DebugType.Groups)),
        [DebugType.Layout]: useAtomValue(debugSettingSelector(DebugType.Layout)),
        [DebugType.Other]: useAtomValue(debugSettingSelector(DebugType.Other)),
        [DebugType.Debug]: useAtomValue(debugSettingSelector(DebugType.Debug)),
    };
}
export function useShowDebugLayout() {
    return useAtomValue(debugSettingSelector(DebugType.Layout));
}
export function useShowDebugConfigurations() {
    return useAtomValue(debugSettingSelector(DebugType.Configuration));
}
export function useShowDebugAttributes() {
    return useAtomValue(debugSettingSelector(DebugType.Attributes));
}
export function useShowDebugValues() {
    return useAtomValue(debugSettingSelector(DebugType.Values));
}
export function useShowDebugGroups() {
    return useAtomValue(debugSettingSelector(DebugType.Groups));
}
export function useShowDebugOther() {
    return useAtomValue(debugSettingSelector(DebugType.Other));
}
//# sourceMappingURL=DebugOptions.js.map